import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import ShoppingCartItems from './ShoppingCartItems';
import app from '../app';

export default Backbone.Model.extend({
    initialize: function () {},

    set: function (key, value, options) {
        // Normalize the key-value into an object
        let attrs;

        if (_.isObject(key) || key === null) {
            attrs = key;
            options = value;
        } else {
            attrs = {};
            attrs[key] = value;
        }

        // Go over all the set attrs and make your changes
        for (const attr in attrs) {
            if (attr === 'shoppingCartItems') {
                attrs[attr] = new ShoppingCartItems(attrs[attr], { shoppingCart: this });
                attrs[attr].on('add', () => this.fetch());
                attrs[attr].on('remove', () => this.fetch());
                attrs[attr].on('change', () => this.fetch());
            }
        }

        return Backbone.Model.prototype.set.call(this, attrs, options);
    },

    urlRoot: function () {
        return `${app.config.contextPath}/shopping_carts`;
    },

    addCatalogItem: function (data, selectReferenceItemId, selectServiceReferenceItemId, optionalSelectProductIds, callback) {

        if (!_.isUndefined(selectReferenceItemId) && selectReferenceItemId !== null) {
            data.selectProductId = selectReferenceItemId;
        }

        if (!_.isUndefined(selectServiceReferenceItemId) && selectServiceReferenceItemId !== null) {
            data.selectServiceProductId = selectServiceReferenceItemId;
        }

        if (!_.isUndefined(optionalSelectProductIds) && optionalSelectProductIds !== null) {
            data.optionalSelectProductIds = optionalSelectProductIds;
        }

        $.ajax({
            url: this.get('shoppingCartItems').url(),
            type: 'POST',

            data: data,

            accepts: { json: 'application/json' },

            success: function (shoppingCartItem, textStatus, jqXHR) {
                const shoppingCart = app.getShoppingCart();

                if (shoppingCartItem.mb2bCountryCode && shoppingCartItem) {
                    window.location.href = `${window.POne.config.contextPath}/shopping_carts/${shoppingCart.id}`;
                } else {
                    shoppingCart.get('shoppingCartItems').add(shoppingCartItem, { merge: true });
                }
            },

            complete: function (jqXHR, textStatus) {
                if (typeof callback !== 'undefined') {
                    return callback(jqXHR, textStatus);
                }
                return undefined;
            },

            error: function (jqXHR, textStatus, errorThrown) {}
        });
    }
});



// WEBPACK FOOTER //
// ./model/ShoppingCart.js